<template>
  <div class="subscConfirm">
    <app-loading class="loading" :isLoading="isLoading"></app-loading>
    <h1 class="subscConfirm__title">お支払い情報を確認</h1>
    <attention-choun v-if="error" :text="error"/>
    <subsc-description-choun
      :item="item"
      :payment-method="payment.method"
    />
    <div class="subscConfirm__foot">
      <form ref="form" :action="action" method="POST" @submit.prevent>
        <input type="hidden" name="_token" :value="form.token">
        <input type="hidden" name="amazonCheckoutSessionId" :value="form.sessionId" />
        <input type="hidden" name="amzpPrefixCode" :value="form.amzp_prefix_code" />
        <input type="hidden" name="return" value="1">
        <input
          v-for="(value, name) in form.params"
          :key="name"
          type="hidden"
          :name="name"
          :value="value"
        />
        <base-button-choun
          class="subscConfirm__modify" 
          :is-disabled="isLoading"
          label="修正する"
          design="cancel"
          @clicked="modify"
        />
        <foot-notice :menu-title="item.menu_title" />
        <base-button-choun
          v-if="!error"
          class="subscConfirm__button"
          :is-disabled="isLoading"
          :label="buttonLabel"
          @clicked="submit"
        />
      </form>
    </div>
  </div>
</template>


<script>
import AttentionChoun from './partials/AttentionChoun'
import BaseButtonChoun from './partials/BaseButtonChoun'
import SubscDescriptionChoun from './partials/SubscDescriptionChoun'
import FootNotice from './partials/FootNotice'

export default {
  name: 'SubscConfirmChoun',
  components:{
    AttentionChoun,
    BaseButtonChoun,
    SubscDescriptionChoun,
    FootNotice,
  },
  data() {
    return {
      action: '',
      isLoading: false,
    }
  },
  props: {
    error: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    payment: {
      type: Object,
      default() {
        return {}
      },
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    chounUser: {
      type: Object,
      default() {
        return {}
      }
    },
    diaryToken: {
      type: String,
      default: ''
    },
  },
  computed: {
    buttonLabel() {
      // this.chounUser.status == 2 は、サブスク停止中、つまり再開(rejoin)
      return this.chounUser.status == 2 ? '購入を再開する' : '購入する'
    }
  },
  methods: {
    modify() {
      this.isLoading = true
      // this.chounUser.status == 2 は、サブスク停止中
      if (this.chounUser.status == 2) {
        window.location.href = `/cd/rejoin/${this.item.menu_id}/${this.diaryToken}`
      } else {
        this.action = this.form.cancel
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      }
    },
    submit() {
      this.isLoading = true
      this.action = this.form.checkout
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.subscConfirm{
  color: #4F4F4F;
  background: #fff;
  padding: 38px 30px 40px;
  max-width: 580px;
  margin: auto;

  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 2px 0 25px;
  }

  &__foot {
    margin: 40px 0 0;
  }
  &__modify {
    margin-bottom: 20px;
  }
  .foot-notice {
    margin: 32px -10px;
  }
}

.loading {
  position: fixed;
  z-index: 3;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/SubscConfirmChoun.vue